export default __webpack_public_path__ + "static/MediaContentEight-1b79288956fd3bc970dbbe9d70c3c8ce.webp";